module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_06_1280_1280_zh-hant-e1b1dc46f45b0c194c088cd317c15cfc.jpg";